import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { AngularFireDatabase } from '@angular/fire/database';
import { ObjectUnsubscribedError, Observable } from 'rxjs';
import { formatDate, DatePipe } from '@angular/common';
import * as firebase from 'firebase';
import { MatStepper } from '@angular/material/stepper';
import { MatCalendarCellCssClasses } from '@angular/material/datepicker';
import LocationPicker from "location-picker";
import * as codigos from './xlsxtojson.json';


@Component({
  selector: 'app-busca-codigo-alumno',
  templateUrl: './busca-codigo-alumno.component.html',
  styleUrls: ['./busca-codigo-alumno.component.css']
})
export class BuscaCodigoAlumnoComponent implements OnInit {

  private codigosAlumnos = codigos;
  CIEstudianteFormGroup: UntypedFormGroup;
  muestraRespuesta = false;
  hayResultado = false;
  objetoDevuelto:Object = null;
  constructor(private _formBuilder: UntypedFormBuilder, public db: AngularFireDatabase, public datePipe: DatePipe) { }

  ngOnInit(): void {
    this.CIEstudianteFormGroup = this._formBuilder.group({
      ApellidosEstudiante: [, [Validators.required]],
      NombresEstudiante: [, [Validators.required]],
    });
  }

  buscar() {
    var arrayAlumnosColegio:[] = [];
    this.objetoDevuelto = null;
    var ApellidosEstudianteInput = this.CIEstudianteFormGroup.get("ApellidosEstudiante").value;
    var NombresEstudianteInput = this.CIEstudianteFormGroup.get("NombresEstudiante").value;
    //const regexApellido = new RegExp('foo*');
    //console.log("ApellidosEstudiante: "+ApellidosEstudiante);
    this.muestraRespuesta = true;
    Object.keys(this.codigosAlumnos).forEach((hoja) => {
      arrayAlumnosColegio = this.codigosAlumnos[hoja];
      //console.log(JSON.stringify(arrayAlumnosColegio));
      Array.prototype.forEach.call(arrayAlumnosColegio, alumno => {
        let apellidosExcel:string = alumno["Apellidos Alumno"];
        let nombresExcel:string = alumno["Nombres Alumno"];
        if(apellidosExcel.toUpperCase().trim() === ApellidosEstudianteInput.toUpperCase().trim() 
        && nombresExcel.toUpperCase().trim() === NombresEstudianteInput.toUpperCase().trim()){
          this.objetoDevuelto = alumno;
          console.log(JSON.stringify(alumno));
        }
      });
      //this.objetoDevuelto = arrayAlumnos.find(alumno => alumno["Apellidos Alumno"] === ApellidosEstudiante.trim() && alumno["Nombres Alumno"] === NombresEstudiante.trim());
    });
    if (this.objetoDevuelto !== null) {
      this.hayResultado = true;
    }
    console.log(JSON.stringify(this.objetoDevuelto));
  }

  nuevaBusqueda() {
    this.CIEstudianteFormGroup.reset();
    this.muestraRespuesta = false;
  }

}
